import { render } from "./Stops.vue?vue&type=template&id=a6bb6320"
import script from "./Stops.vue?vue&type=script&lang=js"
export * from "./Stops.vue?vue&type=script&lang=js"

import "./Stops.vue?vue&type=style&index=0&id=a6bb6320&lang=scss"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__